import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class ITSupportNetworkAudit extends Component {
    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="IT Support Network Audit"
                    subHeadText="Identify weaknesses of your current technology systems and areas for growth"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12 margin5-0">
                                <h4>SICK AND TIRED OF ONGOING TECHNOLOGY PROBLEMS?</h4>
                                <p>
                                    If you just need a system that works the way it’s supposed to, without the hassle of full-time employees, 
                                    we’ve got the answer, with creative and affordable solutions to all your technology problems.<br /><br />

                                    Our Network Audit includes a review of your existing systems.<br />
                                    <ul>
                                        <li>A discussion to understand your business, the challenges you face and the goals you've established.</li>
                                        <li>An overview of the services we offer to help your company grow.</li>
                                        <li>Uncovering hidden problems, that if not addressed, could turn into unexpected downtime.</li>
                                        <li>Locating hidden viruses, spyware, and loopholes in your network security that could allow hackers and viruses to compromise your network and confidential information.</li>
                                        <li>Verifying the integrity of your data backup systems. Backups are often one of the most overlooked steps in securing your data – one of the most critical pieces of your business.</li>
                                        <li>Diagnosing any ongoing problems or concerns you are currently experiencing with your network.</li>
                                        <li>Answering any questions you have about upgrades, adding new equipment or any other project you have in mind.</li>
                                    </ul>
                                </p>
                                <br />
                                <h4>SOLUTIONS WITHOUT THE TECHNICAL JARGON</h4>
                                <p>
                                    Our team will offer professional advice in clear, easy to understand terms. Partner with us today and see 
                                    the difference a knowledgeable and dedicated IT company can make. Let us evaluate your IT systems and find 
                                    ways to increase your productivity, decrease downtime, and save you money.
                                </p>
                                <br />
                            </div>

                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(ITSupportNetworkAudit);


// WEBPACK FOOTER //
// ./src/components/ITSupportNetworkAudit.js